import template from './procedure-templates.html';
import controller from './procedure-templates.controller';

let procedureTemplatesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default procedureTemplatesComponent;
